import { useConversationsStore } from '@/stores/conversations/conversations.store';
import type { ConversationType } from '@/types/conversation.types';
import type { ResolveConversationType } from '@/types/events/resolve-conversation.ts';

export default function resolveConversation(data: ResolveConversationType): void {
  const conversationsStore = useConversationsStore();

  conversationsStore.updateOrInsertConversation(data.conversationData);
  conversationsStore.addNewCacheMessage(data.logMessage);

  if ((conversationsStore.activeConversation as ConversationType)?.conversationId === data.conversationId) {
    conversationsStore.updateActiveConversation(data.conversationData);
    conversationsStore.addNewMessage(data.logMessage);
  }
}
